module.exports = __webpack_public_path__ + "7f661fb0cc9de268c5304e5f754a0f01.svg";